export const NEW_EQUIPMENT_ENDPOINT = {
  getNewEquipmentList: {
    url: '/v1/admin/new-equipment',
    method: 'GET',
  },
  putUpdateEquipmentStatus: (id) => ({
    url: `/v1/admin/equipment/status/${id}`,
    method: 'PUT',
  }),
  uploadWarrantyCertificate: (id) => ({
    url: `/v1/admin/home-inventory/warranty-certificate/${id}`,
    method: 'PUT',
  }),
  getCertificateDetails: (id) => ({
    url: `/v1/admin/home-inventory/get-certificate/${id}`,
    method: 'GET',
  }),
};
